import type { SendMessageDto } from './send-message.dto'

export class SendMessageTemplate {
    static share_link_02(linkPage: string, linkDescription: string, personId: string = null): SendMessageDto {
        let message = `Olá,
        
        Estou compartilhando um conteúdo com você.
        
        Para acessar utilize o link abaixo:
        https://pro.zandu.com.br/${linkPage}
        
        Atenciosamente,
        
        ${window.store.company.companyName}
        ${window.store.company.email}`.replace(/    /g, '')

        let smsMessage = `De ${window.store.company.companyName?.substring(0, 20)}:
        
        Link:
        https://pro.zandu.com.br/${linkPage}`.replace(/    /g, '')

        return {
            message,
            smsMessage,
            subject: window.store.company.companyName + ' - Compartilhamento de conteúdo',
            personId,
            template: {
                name: 'zandu_default_share_link_01',
                replace: { '1': linkDescription, '2': linkPage },
            },
        }
    }

    static share_sign_02(linkPage: string, personId: string = null): SendMessageDto {
        let message = `Olá.
        
        Você está recebendo um link para assinar seu comparecimento.
        
        Para acessar utilize o link abaixo:
        https://agenda.zandu.com.br/${linkPage}
        
        Atenciosamente,
        
        ${window.store.company.companyName}
        ${window.store.company.email}`.replace(/    /g, '')

        let smsMessage = `De ${window.store.company.companyName?.substring(0, 20)}:
        
        Link:
        https://agenda.zandu.com.br/${linkPage}`.replace(/    /g, '')

        return {
            message,
            smsMessage,
            personId,
            subject: window.store.company.companyName + ' - Assinatura de comparecimento',
            template: {
                name: 'zandu_default_share_sign_01',
                replace: { '1': linkPage },
            },
        }
    }
}
